export default __webpack_public_path__ + "static/media/pomodoro.c676268f.png";